import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useUsersMeCached } from '@helloworld1812/hr-api';

import { useHrQuery } from '@/api';
import {
  UserOnboardingWelcomeModal,
  OnboardingStep,
  onboardingPageSteps,
} from '@/folder-components/user-onboarding-page';

export function AuthorizedRedirects() {
  const location = useLocation();
  const isOnboardingPage = location.pathname === '/user-onboarding';
  const isLoginPage = location.pathname === '/login';
  const isSuccessLoginPage = location.pathname === '/success-login';
  const isRedirectPage = location.pathname === '/redirect';
  const { user } = useUsersMeCached();
  const onboardingStep = user.user_onboarding_desktop_step as OnboardingStep;
  const isSuperAdmin = user.is_super_admin;
  const { data: resetPwdTokenData } = useHrQuery(
    {
      url: '/v1/users/reset_password_token',
    },
    {
      enabled: !!user.reset_password_required,
    }
  );
  const resetPwdToken = resetPwdTokenData?.reset_password_token;

  if (resetPwdToken) {
    return <Redirect to={`/set-password/${resetPwdToken}`} />;
  }

  if (!isOnboardingPage && !isSuperAdmin && onboardingPageSteps.includes(onboardingStep)) {
    return <Redirect to="/user-onboarding" />;
  }

  // Authorized but still in unauthenticated flow
  if (isLoginPage || isSuccessLoginPage || isRedirectPage) {
    return <Redirect to="/" />;
  }

  // User is in the last welcome step of onboarding flow
  if (!isSuperAdmin && onboardingStep === 'welcome_modal') {
    return <UserOnboardingWelcomeModal />;
  }

  return null;
}
